document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll<HTMLElement>(".grid-rich-text .text-content").forEach((content) => {
    const desktopCollapse = content.dataset.desktop === "true";
    const mobileCollapse = content.dataset.mobile === "true";
    const desktopRows = parseInt(content.dataset.desktopRows || "3", 10);
    const mobileRows = 5;

    if (!(desktopCollapse || mobileCollapse)) return;

    // Detect if mobile or desktop
    const isMobile = () => window.innerWidth <= 768;
    let collapsedLines = isMobile() ? mobileRows : desktopRows;

    // Respect flags: Exit if collapse is not allowed on the current view
    if ((isMobile() && !mobileCollapse) || (!isMobile() && !desktopCollapse)) return;

    // Function to get full expanded height
    const getExpandedHeight = (element: HTMLElement): number => {
      const clone = element.cloneNode(true) as HTMLElement;
      clone.style.position = "absolute";
      clone.style.visibility = "hidden";
      clone.style.maxHeight = "none";
      clone.style.overflow = "visible";
      clone.style.whiteSpace = "normal";
      clone.style.display = "block";
      clone.style.width = `${element.clientWidth}px`;
      element.parentNode?.appendChild(clone);
      const height = clone.scrollHeight;
      element.parentNode?.removeChild(clone);
      return height;
    };

    // Measure expanded height BEFORE applying clamping
    const expandedHeight = getExpandedHeight(content);

    // Step 1: Apply clamping
    content.style.overflow = "hidden";
    content.style.display = "-webkit-box"; // Ensure clamping works correctly
    content.style.webkitBoxOrient = "vertical";
    content.style.textOverflow = "ellipsis";
    content.style.webkitLineClamp = collapsedLines.toString();
    content.style.transition = "height 0.3s ease-in-out";

    // Step 2: Wait for the browser to render the clamping
    requestAnimationFrame(() => {
      setTimeout(() => {
        // Step 3: Measure the collapsed height AFTER clamping has been applied
        const collapsedHeight = content.offsetHeight;

        // Store values in data attributes
        content.setAttribute("data-expanded-height", expandedHeight.toString());
        content.setAttribute("data-collapsed-height", collapsedHeight.toString());

        console.log("Collapsed height: " + collapsedHeight.toString());
        console.log("Expanded height: " + expandedHeight.toString());

        // Set collapsed height explicitly on load to prevent unwanted expansion
        content.style.height = `${collapsedHeight}px`;
      }, 100);
    });

    // Ensure button isn't added multiple times
    if (content.parentNode?.querySelector(".toggle-collapse")) return;

    // Create "More/Less" button
    const toggleButton = document.createElement("button");
    toggleButton.innerText = "More";
    toggleButton.classList.add("more-button");
    Object.assign(toggleButton.style, {
      marginTop: "10px",
    });

    let expanded = false;
    toggleButton.addEventListener("click", () => {
      if (!expanded) {
        // EXPAND: First, set display to block so animation works
        content.style.display = "block";

        // Add a delay before changing the height
        setTimeout(() => {
          content.style.height = `${content.getAttribute("data-expanded-height")}px`;
        }, 100);

        toggleButton.innerText = "Less";
      } else {
        // COLLAPSE: Set height back to collapsed height
        content.style.height = `${content.getAttribute("data-collapsed-height")}px`;

        // After the animation completes, reset display & reapply clamping to restore "..."
        setTimeout(() => {
          content.style.display = "-webkit-box"; // Set back to -webkit-box
        }, 300); // Matches transition duration

        toggleButton.innerText = "More";
      }
      expanded = !expanded;
    });

    content.parentNode?.appendChild(toggleButton);

    // Ensure clamping updates on window resize
    window.addEventListener("resize", () => {
      if (!expanded) {
        if ((isMobile() && !mobileCollapse) || (!isMobile() && !desktopCollapse)) {
          content.style.webkitLineClamp = "none";
          content.style.height = "auto";
          toggleButton.style.display = "none"; // Hide button if collapsing is disabled
        } else {
          collapsedLines = isMobile() ? mobileRows : desktopRows;
          content.style.webkitLineClamp = collapsedLines.toString();
          toggleButton.style.display = "block"; // Show button if collapsing is enabled
        }
      }
    });
  });
});
